export default __webpack_public_path__ + "static/media/Bolo-de-Bacalhau.212287c3.jpg";